import { Auth } from '../src/api/Auth';
import { ContentManager } from "../src/helpers/ContentManager";
import { Api } from "../src/api/Api";
import { GetDataHelper } from "../src/helpers/GetDataHelper";
import { initGlobalStore } from "../src/store";
import { setAuthRegButtonListeners } from "../src/listners/setAuthRegButtonListeners";
import { setOrderCreateFormListener } from "../src/listners/setOrderCreateFormListener";
import { updateCityInUserProfile } from '../src/functions/updateCityInUserProfile';
import { setAddAddressFormListener } from "../src/listners/setAddAddressFormListener";
import { resolveTopBar } from "../src/functions/resolveTopBar";
import { initMasks } from "../src/helpers/InitMasks";

import {addClickEvent} from "../src/functions/mapHelpers"

const Swal = require('sweetalert2')

window.content = new ContentManager();
window.auth = new Auth();
window.DataHelper = new GetDataHelper();
window.api = new Api();

// initInterface(); // jquery legacy
initGlobalStore(); // gloal store for buttons and inputs
$("#authPrompt").hide();
$("#cartIsEmpty").hide();
$("#orderCreateForm").hide();
setAuthRegButtonListeners(() => location.reload());


const translateWorkingTime = (deliveryhours) => {
  let lang = localStorage.getItem('currentLang') || 'ru'
  const translates = {
    "ru": `Ресторан работает с ${deliveryhours[0]} по ${deliveryhours[1]}. Оформите доставку в другое время`,
    "kz": `Мейрамхана сағат ${deliveryhours[0]}-ден ${deliveryhours[1]}-ге дейін жұмыс істейді. Жеткізуді басқа уақытта ұйымдастырыңыз`,
    "en": `The restaurant is open from ${deliveryhours[0]} to ${deliveryhours[1]}. Arrange delivery at another time`,
  }
  // console.log(translates[lang.toLowerCase()])
  return translates[lang.toLowerCase()]
}

const translates = {
  "restaurant_isnt_working": {
    "ru":"Ресторан не работает",
    "kz":"Мейрамхана жұмыс істемейді",
    "en":"Restaurant isn't working"
  },
  "to_main_page": {
    "ru":"На главную",
    "kz":"Басты бетке",
    "en":"To main page"
  },
}

const translate = (key) => {
  let lang = localStorage.getItem('currentLang') || 'ru'
  if (translates[key]) {
    return translates[key][lang.toLowerCase()]
  }
}

function onLogin() {
  Promise.all([
    api.getPaymentMethods(),
    api.getDeliveryTimes(),
    api.getAddresses(),
    api.getRestaurantList(),
  ]).then(([paymentMethods, deliveryTimes, addresses, { restaurants }]) => {
    $("#authPrompt").hide();

    const city = JSON.parse(localStorage.getItem('currentCity'));
    const currentCityRestaurants = restaurants.filter(r => {
      if (city) {
        return r.city_uuid === city.uuid
      }
      return false
    });

    content.setCheckoutDeliveryPickup(restaurants);
    content.setCheckoutRestaurantsField(currentCityRestaurants);
    content.setCheckoutAnothermanFields();
    content.setCheckoutAddressAndDeliveryTimeFields(addresses, deliveryTimes);
    content.setCheckoutPaymentMethods(paymentMethods);
    content.setCheckoutBonusFields();

    setAddAddressFormListener((addresses, defaultValue = '', formData) => {
      content.setCheckoutAddressAndDeliveryTimeFields(addresses, deliveryTimes);
      let addressesReversed = JSON.parse(JSON.stringify(addresses)).reverse();
      
      $('#addressesSelect').val(defaultValue);
      $('#addressesSelectHidden').val(defaultValue);
      $('#freefrom').val(addressesReversed[0].freefrom);
      console.log('freefrom заменился чекаут');

      const cart = JSON.parse(localStorage.getItem("cart"));
    const pricesSum = cart.reduce((acc, cur) => {
      const totalPriceForDish = Number(cur.price) * Number(cur.count);
      return acc + totalPriceForDish;
    }, 0);

      let doesItFree = pricesSum >= $('#freefrom').val()? 0 : Number($('#address_price').val())
      if(document.querySelector('span#delivery_price') && doesItFree > 0){
        // document.querySelector('span#delivery_price').innerHTML = doesItFree
        setPage()
      }
    });

    const cart = localStorage.getItem("cart");
    if (cart) {
      $("#orderCreateForm").fadeIn();
    } else {
      $("#cartIsEmpty").fadeIn();
    }
    setOrderCreateFormListener();
  }).catch(error => console.log("error in login function:", error));
}

function main() {

  console.log({ api });
  updateCityInUserProfile();
  Promise.all([api.getUserProfile(), api.getUsersBonusBalance()]).then(() => {
    content.setProfileHeader(DataHelper.store.user, DataHelper.store.bonuses);
    content.hideModalWindows(false);
    $("#authPrompt").hide();
    onLogin();
  })
    .catch(error => {
      console.log("error on auth check: ", error)
      $("#authPrompt").fadeIn();
    })
    .finally(() => {
      setPage();
    });
}


function setPage() {
  resolveTopBar(({ changedCity, restaurants }) => {
    const city = JSON.parse(localStorage.getItem('currentCity')) || changedCity;
    const currentCityRestaurants = restaurants.filter(r =>
      r.city_uuid === city.uuid);
    content.setCheckoutRestaurantsField(currentCityRestaurants);
  }).then(({ baseCity }) => {
    const city = JSON.parse(localStorage.getItem('currentCity')) || baseCity;
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    const lang = localStorage.getItem('currentLang') || 'ru';

    Promise.all(cart.map(c => api.getDishId(c.id, city, lang))).then((res) => {
      api.getAdditionalDishes(cart.map(c => c.id), lang).then((additionalDishes) => {
        const cartItem = res.map(r => ({
          ...r.menuitem,
          quantity: cart.find(c => c.id === r.menuitem.uuid).count
        }));
        content.setCheckoutCartItems(cartItem, additionalDishes.slice(0, 3));
        content.setCheckoutTotals();
      })


    }).catch(error => console.log("error in setTopBarAndCartItems function: ", error))
    
    $('#products-summary').hide();
  })
}


document.querySelector('#mapAddressBtn').addEventListener('click', function(e) {
  console.log('Накинул ивент на кнопку "Карта(checkout)"')
  // console.log(initMap());
  console.log(addClickEvent());
  initMap(addClickEvent)
  // $('#mapAddressModal').fadeIn()
}, {isOnce: true})

main();
initMasks();
